import { buildClassName } from 'utils/build-class-name';
import styles from './styles.module.scss';
import Button, { SECONDARY_THEME } from 'components/control/button';
import Image from 'next/image';
import Link from 'components/link';
import { ProgramData } from 'tenants';
import { useTranslation } from 'next-i18next';

type ProgramCardProps = {
  program: ProgramData;
  index: number;
  marginIncrement: number;
  thriveTextRef?: React.RefObject<HTMLDivElement>;
  onButtonClick?: (index: number) => void;
};

export default function ProgramCard({ program, index, marginIncrement, onButtonClick, thriveTextRef }: ProgramCardProps) {
  const { t } = useTranslation();
  return (
    // eslint-disable-next-line react/no-unknown-property
    <div key={index} className={buildClassName('card', styles.card)} animation-item={`${(index+1)*marginIncrement}`}>
      <div className={styles['card-container']}>
        <div className={buildClassName('image-container', styles['image-container'])}>
          <Image src={program.image} alt={`eXp Realty ${t(program.title)} Program`} fill />
        </div>
        <div
          className={buildClassName('content-container', styles['content-container'], index === 1 ? 'thrive-text' : '' )}
          ref={index === 1 ? thriveTextRef : null}
        >
          <div className={styles['card-number']}>{`0${index + 1}`}</div>
          <h3>{t(program.title)}</h3>
          <p>{t(program.description)}</p>
          <Link onClick={() => onButtonClick?.(index)} href={program.buttonLink} target="_blank" rel="noopener noreferrer">
            <Button theme={SECONDARY_THEME} label={t(program.buttonText)} />
          </Link>
        </div>
      </div>
    </div>
  );
}